import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import Datetime from 'react-datetime';
import "moment/locale/en-gb";
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import { saveAs } from 'file-saver';
import "react-datetime/css/react-datetime.css";
import QRCode from 'qrcode';

moment.updateLocale("en-gb", {
    week: {
        dow: 1,
    },
});

const UpdateContact = (props) => {

    const { updateContract, maxSerialNumber, tab, isNewContract, openModal, setNewContractAdded, serial_number } = props;
    const [contract, setContract] = useState(updateContract);
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    const [date, setDate] = useState(moment().format("DD.MM.YYYY"));
    useEffect(() => {
        if (isNewContract) {
            setContract({ ...contract, date: date, serial_number: date.split(".").pop() + "-" + updateContract.serial_number });
        } else {
            setContract({ ...contract, date: date });
        }
    }, [date]);

    const handleClickedUpdateContract = async () => {
        const { date, length, ship_name, serial_number, company_name } = contract;

        const fileName = simplifyKey(`DOC ${tab.name} No. ${serial_number} ${length.replace(/\//g, '')} ${ship_name} ${date}.pdf`);

        await modifyPdf({ ...contract, ship_name: ship_name, file_name: simplifyKey(fileName) }, tab);
    };

    async function modifyPdf(contract, tab) {
        setDisableSaveButton(true);

        const { serial_number, length, ship_name, date, file_name, company_name, imo_no, step_quantity } = contract;

        const url = `${process.env.REACT_APP_BACKEND_UPLOAD_LOCATION}/empty/${tab.type}.pdf`;
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        pdfDoc.registerFontkit(fontkit);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];

        const { width, height } = firstPage.getSize();

        const fontUrl = `${process.env.REACT_APP_BACKEND_URL}/fonts/DejaVuSans-Bold.ttf`;
        const dejavuSansBoldBuffer = await fetch(fontUrl).then(res => res.arrayBuffer());
        if (!dejavuSansBoldBuffer) {
            console.error("Failed to load DejaVuSans-Bold font buffer");
            return;
        }
        const dejavuSansBold = await pdfDoc.embedFont(dejavuSansBoldBuffer);

        switch (tab.type) {
            case 'pilot_ladder_contracts': {

                // Serial No. / Batch No.
                firstPage.drawText(serial_number, {
                    x: 236,
                    y: 470,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });
                if (date) {
                    const year = date.split(".")[2];
                    firstPage.drawText(year, {
                        x: 236,
                        y: 455,
                        size: 10,
                        font: dejavuSansBold,
                        color: rgb(1, 0, 0),
                    });
                }
                // Vessel Name (Ship Name + IMO No)

                const vesselDisplay = imo_no ? `${ship_name} (${imo_no})` : `${ship_name} ( - )`;
                firstPage.drawText(vesselDisplay, {
                    x: 236,
                    y: 440,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });
                firstPage.drawText(length ?? '', {
                    x: 256,
                    y: 402,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });
                // Step Quantity (right sub-column, same row)
                if (step_quantity) {
                    firstPage.drawText(String(step_quantity), {
                        x: 356,
                        y: 402,
                        size: 10,
                        font: dejavuSansBold,
                        color: rgb(1, 0, 0),
                    });
                }
                // Date of Production
                if (date) {
                    firstPage.drawText(String(date), {
                        x: 236,
                        y: 380,
                        size: 10,
                        font: dejavuSansBold,
                        color: rgb(1, 0, 0),
                    });
                }
                // Place & Date on Page 2 (Rotterdam pre-printed)
                const secondPage = pages[1];
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];
                const monthIndex = parseInt(date.split(".")[1]) - 1;
                const monthName = monthNames[monthIndex];
                const converterDate = date.split(".")[0] + " " + monthName + " " + date.split(".")[2];
                secondPage.drawText(`${converterDate}`, {
                    x: 280,
                    y: 210,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(0, 0, 0),
                });
                break;
            }
            case 'embed_ladder_contracts':
                firstPage.drawText(`${serial_number.split("-")[1] ? serial_number.split("-")[1] : serial_number}    ${length}    ${ship_name}`, {
                    x: 252,
                    y: height - 495,
                    size: 12,
                    font: dejavuSansBold,
                    color: rgb(1, 0, 0),
                });

                firstPage.drawText(`${date}`, {
                    x: 183,
                    y: height - 655,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(0, 0, 0),
                });
                break;
            case 'firemans_outfit_contracts':
                firstPage.drawText(`${date}`, {
                    x: 175,
                    y: height - 733,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(0, 0, 0),
                });
                break;
            default:
                console.error("Unknown contract type");
                return;
        }

        const qrUrl = await createPresignedUrl(file_name);
        const qrWidth = 100;
        const qrHeight = 100;
        const qrCodeDataUrl = await QRCode.toDataURL(qrUrl, {
            margin: 1,
            width: qrWidth,
        });
        const qrImage = await pdfDoc.embedPng(qrCodeDataUrl);

        // 6. QR kodunu PDF'in sağ üst köşesine ekleyin
        if (tab.type !== 'pilot_ladder_contracts') {
            firstPage.drawImage(qrImage, {
                x: width - qrWidth - 30,
                y: height - qrHeight - 30,
                width: qrWidth,
                height: qrHeight,
            });
        } else {
            firstPage.drawImage(qrImage, {
                x: 500,
                y: 600,
                width: qrWidth,
                height: qrHeight,
            });
        }

        const pdfBytes = await pdfDoc.save();
        const formData = new FormData();
        formData.append("file", new Blob([pdfBytes], { type: "application/pdf" }), file_name);
        formData.append("fileName", file_name);
        formData.append("contractData", JSON.stringify({
            id: isNewContract ? null : contract.id,
            length,
            ship_name: ship_name,
            date,
            file_name: file_name,
            url: qrUrl,
            serial_number: serial_number,
            company_name: company_name || '',
            contract_type: tab.type,
            imo_no: imo_no || null,
            step_quantity: step_quantity || null,
            date_of_production: null,
        }));

        const updateUrl = isNewContract ? `${process.env.REACT_APP_BACKEND_URL}/createContract` : `${process.env.REACT_APP_BACKEND_URL}/updateContract`;
        const response = await fetch(updateUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Failed to upload PDF');
        }

        saveAs(new Blob([pdfBytes]), file_name);
        openModal(false)
        setDisableSaveButton(false);
        setNewContractAdded(true);
    }

    function simplifyKey(filename) {
        const charMap = {
            'ı': 'i',
            'İ': 'I',
            'ö': 'o',
            'Ö': 'O',
            'ü': 'u',
            'Ü': 'U',
            'ş': 's',
            'Ş': 'S',
            'ç': 'c',
            'Ç': 'C',
            'ğ': 'g',
            'Ğ': 'G',
            ' ': '_',  // Replace spaces with underscores
        };

        // Use the map to replace characters in the filename
        const cleanedFilename = filename
            .split('')
            .map(char => charMap[char] || char)  // Replace if in the map, otherwise keep the original character
            .join('')
            .replace(/[^a-zA-Z0-9._-]/g, '_'); // Replace remaining special characters with underscores

        return cleanedFilename;
    }

    function createPresignedUrl(fileName) {
        return `${process.env.REACT_APP_BACKEND_URL}/certifications/pdf/${fileName}`;
    }

    return (
        <div className='absolute top-0 right-0 flex flex-col w-[100%] overflow-hidden h-[100vh] backdrop-blur-md flex justify-center items-center'>
            <div className='w-full md:w-[30%]  text-right '>

                <button
                    onClick={() => openModal(false)}
                    type="button"
                    className="m-2 rounded bg-red-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                >

                    <svg className='w-6 h-6' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6M6 6l12 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                </button>
            </div>

            <div className='w-full p-3 bg-white items-center justify-center md:w-[30%] rounded-md border-2'>
                <div className='m-2'>
                    <label htmlFor="contract_id" className="block text-sm font-medium leading-6 text-gray-900">
                        Date
                    </label>
                    <div className="">
                        <Datetime value={contract.date} onChange={(date) => { setDate(moment(date).format("DD.MM.YYYY")) }} locale="en-gb" timeFormat={false} dateFormat={"DD.MM.yyyy"} initialValue={new Date()} className="border block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 " />
                    </div>
                </div>
                <div className='m-2'>
                    <label htmlFor="contract_id" className="block text-sm font-medium leading-6 text-gray-900">
                        Serial Number
                    </label>
                    <div>
                        <input
                            id="serial_number"
                            name="text"
                            type="text"
                            disabled={!isNewContract}
                            placeholder={"2023-"}
                            onChange={(e) => setContract({ ...contract, serial_number: e.target.value })}
                            value={contract.serial_number}
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className='m-2'>
                    <label htmlFor="length" className="block text-sm font-medium leading-6 text-gray-900">
                        Length
                    </label>
                    <div >
                        <input
                            id="length"
                            name="text"
                            type="text"
                            value={contract["length"]}
                            onChange={(e) => setContract({ ...contract, length: e.target.value })}
                            placeholder="e.g. 7 MT / 8 MT / 9 MT "
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className='m-2'>
                    <label htmlFor="ship_name" className="block text-sm font-medium leading-6 text-gray-900">
                        Ship Name
                    </label>
                    <div>
                        <input
                            id="ship_name"
                            name="text"
                            type="text"
                            value={contract.ship_name}
                            onChange={(e) => setContract({ ...contract, ship_name: e.target.value })}
                            placeholder=""
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className='m-2'>
                    <label htmlFor="company_name" className="block text-sm font-medium leading-6 text-gray-900">
                        Company Name
                    </label>
                    <div>
                        <input
                            id="company_name"
                            name="text"
                            type="text"
                            value={contract.company_name || contract.companyName || ''}
                            onChange={(e) => setContract({ ...contract, company_name: e.target.value })}
                            placeholder=""
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                {tab.type === 'pilot_ladder_contracts' && (
                    <>
                        <div className='m-2'>
                            <label htmlFor="imo_no" className="block text-sm font-medium leading-6 text-gray-900">
                                IMO No
                            </label>
                            <div>
                                <input
                                    id="imo_no"
                                    name="text"
                                    type="text"
                                    value={contract.imo_no || ''}
                                    onChange={(e) => setContract({ ...contract, imo_no: e.target.value })}
                                    placeholder="e.g. 1234567"
                                    className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div className='m-2'>
                            <label htmlFor="step_quantity" className="block text-sm font-medium leading-6 text-gray-900">
                                Step Quantity
                            </label>
                            <div>
                                <input
                                    id="step_quantity"
                                    name="text"
                                    type="number"
                                    value={contract.step_quantity || ''}
                                    onChange={(e) => setContract({ ...contract, step_quantity: e.target.value })}
                                    placeholder="e.g. 25"
                                    className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>


                    </>
                )}

                <div className='m-2'>
                    <label htmlFor="contract_type" className="block text-sm font-medium leading-6 text-gray-900">
                        Contract Type
                    </label>
                    <div>
                        <input
                            id="contract_type"
                            name="text"
                            type="text"
                            value={tab.name}
                            disabled={true}
                            placeholder=""
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <button
                    onClick={handleClickedUpdateContract}
                    type="button"
                    disabled={disableSaveButton}
                    className="m-2 rounded bg-indigo-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                    Update Contract
                </button>
            </div>
        </div>

    )
}

export default UpdateContact;